export default __webpack_public_path__ + "static/media/react.e7f2e626.svg";